import {clsx} from 'clsx';
import React, {forwardRef, InputHTMLAttributes, ReactNode} from 'react';

const INPUT_CONTAINER_CLASSES = (isNewItem: boolean) =>
  clsx(
    'flex flex-row items-center gap-4 grow shrink',
    'px-8 py-4',
    'bg-white dark:bg-moon-900',
    'text-moon-800 dark:text-moon-200',
    {
      'rounded-sm outline outline-1 outline-moon-250 dark:outline-moon-700':
        !isNewItem,
      'rounded-sm': isNewItem,
    },
    'night-aware'
  );

const INPUT_CLASSES = clsx(
  'flex-1 bg-inherit',
  'leading-8 h-24',
  'appearance-none border-none',
  'focus:outline-none',
  'placeholder-moon-500',
  'dark:selection:bg-moon-650 dark:selection:text-moon-200'
);

type InlineComboboxInputProps = {
  /**
   * Allow something to be inserted before the input box. Probably an icon or
   * something.
   */
  beforeInput?: ReactNode;
  /**
   * If true, removes the outline styling. Used when adding new items.
   */
  isNewItem?: boolean;
} & InputHTMLAttributes<HTMLInputElement>;

export const InlineComboboxInput = forwardRef<
  HTMLInputElement,
  InlineComboboxInputProps
>(function InlineComboboxInput(
  {beforeInput, isNewItem = false, capture, ...props},
  forwardedRef
) {
  return (
    <div className={INPUT_CONTAINER_CLASSES(isNewItem)}>
      {beforeInput}
      <input {...(props as any)} ref={forwardedRef} className={INPUT_CLASSES} />
    </div>
  );
});
